import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  accountingEntriesFilterJournalTypeSelector,
  accountingEntriesChangeFilterJournalType,
  accountingEntriesFilterJournalTypeOptionsSelector,
  accountingJournalTypesGetRequested,
} from '../../../state';
import { SelectFlexSales, SimpleSelectProps } from '../../selects';

type StatusFilterProps = Pick<SimpleSelectProps, 'fullWidth'>;

const JournalTypeFilter = (props: StatusFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const value = useSelector(accountingEntriesFilterJournalTypeSelector);

  const journalTypes = useSelector(accountingEntriesFilterJournalTypeOptionsSelector);
  const disabled = !journalTypes.loaded;
  const options = journalTypes.data || [];
  const handleChange = useCallback(
    (value: string | null) => dispatch(accountingEntriesChangeFilterJournalType(value)),
    [dispatch]
  );

  useEffect(() => {
    if (!journalTypes.loaded && !journalTypes.loading && !journalTypes.failure) {
      dispatch(accountingJournalTypesGetRequested());
    }
  }, [dispatch, journalTypes]);
  return (
    <SelectFlexSales
      {...props}
      label={t('accountingEntries.columns.journalType')}
      onChange={handleChange}
      disabled={disabled}
      value={value}
      options={options}
      loading={journalTypes.loading}
    />
  );
};

export default JournalTypeFilter;
